/**
 * ChatDaySeparator — the date pill that heads each day's run of messages.
 *
 * The label is formatted here rather than inside `buildChatTimeline` because it
 * is localized: formatting at render time keeps it correct after a language
 * change, which a label cached in the memoized timeline would not be.
 */
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { formatContentDayLabel } from '@wlb/shared/utils/dateHelpers';
import './messages.css';

interface ChatDaySeparatorProps {
  date: Date;
}

export function ChatDaySeparator({ date }: ChatDaySeparatorProps) {
  // Subscribes the pill to language changes; the label itself comes from the
  // shared formatter so web and mobile separators read the same.
  useTranslation();
  return <div className="chat-day-separator">{formatContentDayLabel(date)}</div>;
}
